import {
  Button,
  makeStyles,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import { MdPersonAddAlt1 } from 'react-icons/md';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export function useGlosaries() {
  const [glosaries, setGlosaries] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/glosary')
      .then((response) => response.json())
      .then((data) => {
        setGlosaries(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { glosaries, setGlosaries };
}

export default function CreateGlosary() {
  const classes = useStyles();
  const { glosaries, setGlosaries } = useGlosaries();
  const [letter, setLetter] = React.useState('');
  const [word, setWord] = React.useState('');
  const [definition, setDefinition] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedGlosary, setSelectedGlosary] = React.useState(null);
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (letter && word) {
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/glosary',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              letter,
              word,
              definition,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          setGlosaries([...glosaries, data?.data]);
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setLetter('');
        setWord('');
        setDefinition('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleUpdate = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/glosary/${selectedGlosary?._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            letter,
            word,
            definition,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        let index = glosaries.findIndex((g) => g?._id === selectedGlosary?._id);
        glosaries.splice(index, 1, data?.data);
        setGlosaries(glosaries);
        setSelectedGlosary(data?.data);
        setSnackCreateSuccessOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleDelete = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/glosary/${selectedGlosary?._id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            letter,
            word,
            definition,
          }),
        }
      );

      let data = await response.json();
      if (data.success) {
        let glosariesDeleted = glosaries.filter(
          (g) => g?._id !== selectedGlosary?._id
        );
        setGlosaries(glosariesDeleted);
        setSnackCreateSuccessOpen(true);

        setLetter('');
        setWord('');
        setDefinition('');
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  useEffect(() => {
    if (selectedGlosary) {
      setLetter(selectedGlosary?.letter);
      setWord(selectedGlosary?.word);
      setDefinition(selectedGlosary?.definition);
    }
  }, [selectedGlosary]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Letra</StyledTableCell>
              <StyledTableCell>Palabra</StyledTableCell>
              <StyledTableCell>Definición</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {glosaries.map((row) => (
              <StyledTableRow
                onClick={() => setSelectedGlosary(row)}
                key={row?._id}
              >
                <StyledTableCell>{row?.letter}</StyledTableCell>
                <StyledTableCell>{row?.word}</StyledTableCell>
                <StyledTableCell>{row?.definition}</StyledTableCell>
                <StyledTableCell>{row?.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, mediante este formulario usted podrá crear,
          actualizar o eliminar palabras para el glosario de la plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Letra"
          variant="outlined"
          value={letter}
          onChange={(e) => setLetter(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Palabra"
          variant="outlined"
          value={word}
          onChange={(e) => setWord(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Definición"
          variant="outlined"
          value={definition}
          onChange={(e) => setDefinition(e.target.value)}
        />
        <Button
          onClick={() => {
            setSelectedGlosary(null);
            setLetter('');
            setWord('');
            setDefinition('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          <Button variant="contained" color="secondary" onClick={handleDelete}>
            <FaTrash size={15} />
            Eliminar
          </Button>
          <Button variant="contained" onClick={handleUpdate}>
            <AiFillEdit size={15} />
            Actualizar
          </Button>
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado el administrador exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear un nuevo usuario, por favor llene
          los campos requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
